import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {CheckModalComponent} from '../../../check-save-modal/check-modal';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import * as _ from 'lodash';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ModulesService} from '../../../../../core/services/modules.service';
import {FuseDeleteDialogComponent} from '../../../../../core/components/delete-dialog/delete-dialog.component';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'module-detail',
    templateUrl: './module-detail.component.html',
    styleUrls: ['./module-detail.component.scss'],
    standalone: false
})

export class ModuleDetailComponent implements OnInit {
  public returnBack;
  defaultForm;
  id;
  pages;
  formGroup: FormGroup = new FormGroup({
    title: new FormControl('', Validators.required) ,
    description: new FormControl('') ,
    url: new FormControl('') ,
    pageId: new FormControl('', Validators.required) ,
    status: new FormControl(false)
  });
  constructor(private route: ActivatedRoute,  public dialog: MatDialog, public snackBar: MatSnackBar,
              public modulesService: ModulesService,  private router: Router,
              public toastr: ToastrService, public translate: TranslateService,
              private spinner: NgxSpinnerService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
  }

  ngOnInit() {
    this.getPages();
    if (this.id) {
      this.getPlatform();
    }
  }

  getPages(){
    this.modulesService.getPages().subscribe(res => {
      this.pages = res;
    });
  }

  getPlatform() {
    this.modulesService.getModuleById(this.id).subscribe(res => {
      if (res) {
        this.formGroup.patchValue(res);
        this.defaultForm = this.formGroup.value;
      }
    });
  }

  addModule(returnToPlatform){
    const data = this.formGroup.value;
    data.id = this.id;
    if (this.id) {
      data.id = +this.id;
    }
    this.modulesService.addModule(data).subscribe((res) => {
      this.returnBack = returnToPlatform;
      if (res && returnToPlatform) {
        let text = '';
        if (this.id) {
          text = this.translate.instant('platform.platformEdited');
        } else {
          text = this.translate.instant('platform.platformAdded');
        }
        this.toastr.success(text, 'Success!');
        this.router.navigate([ './pages/settings/modules' ]);
      }
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack(): any{
    let dialogRef;
    if ((!this.compareForms()) && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog',
        width: '70vw',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.formGroup.valid) {
            this.addModule(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly', '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  compareForms() {
    if (!this.id) {
      const values = Object.values(this.formGroup.value);
      const changes = values.filter(x => x && x !== '');
      return changes.length ? false : true;
    } else {
      return _.isEqual(this.formGroup.value , this.defaultForm);
    }
  }

  enable() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , {
      panelClass: 'unsave-form-dialog',
      width: '400px' , height: 'auto',
      data: {title: 'enable_module' , message: 'enable_module_msg'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.modulesService.enableModuleToAllOrg(this.id).subscribe(res => {
          this.spinner.hide();
          let text = this.translate.instant('module.moduleEdited');
          this.toastr.success(text, 'Success!');
        });
      }
    });
  }
}
